export const Loaders = {
  SIZE: 6,
  GAP: 8,
};
